export default __webpack_public_path__ + "static/media/fox-banner.5820039c.png";